import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {
  ItemAvailability,
  V3Chapter,
  V3Exam,
  V3ExamSession,
  V3Exercise,
  V3ExerciseSession,
  V3Section
} from '../../model/v3/cspa';
import {NativeServiceApiProvider} from '../../../services/native-api-provider.service';
import {combineLatest, switchMap} from 'rxjs';
import {AuthorizationServiceProvider} from 'src/app/auth_profile/services/authorization-service.provider';

@Component({
    selector: 'exercise-square',
    templateUrl: './exercise-square.component.html',
    styleUrls: ['./exercise-square.component.scss'],
    standalone: false
})
export class ExerciseSquareComponent implements OnInit {
  private _section: V3Section
  @Input() availability: ItemAvailability;
  @Input() exercise: V3Exercise | V3Exam;
  @Input()
  get section(): V3Section {
    return this._section
  }

  set section(section: V3Section) {
    this._section = section
    this.sectionPath = section.path
  }
  sectionPath: string;
  @Input() chapter?: V3Chapter;

  path: string;
  fullpath: string;
  role: string;
  personId: number;

  @Output() openLockedExerciseSetModal = new EventEmitter<void>();
  @Output() openCompletedExamResultModal = new EventEmitter<V3Exam>();

  constructor(
    private provider: NativeServiceApiProvider,
    private router: Router,
    private route: ActivatedRoute,
    private authServiceProvider: AuthorizationServiceProvider
  ) {}

  ngOnInit(): void {
    combineLatest([
      this.authServiceProvider.getAuthDetailsService().pipe(
        switchMap(detailsApi => combineLatest([
          detailsApi.getUserRole(),
          detailsApi.getSelfPersonId()
        ]))
      ),
      this.route.paramMap
    ]).subscribe(([[role, personId], params]) => {
      this.role = role
      this.personId = personId

      this.path = `${this.exercise.path}`
      this.fullpath = (this.role === "Teacher" ? '/teacher/' : '/student/').concat('', `exercises/${params.get('exerciseSet')}/${params.get('chapter')}/${this.exercise.path.split('_').slice(2).join('/')}`)
    })
  }

  getStatusClass(): string {
    if (!this.availability) return 'locked';
    if (!this.availability.isAssigned || !this.availability.isAvailable)
      return 'locked';
    if (this.isExam() && this.isBlocked())
      return 'completed';
    if (this.availability.score === 0) return 'ready';
    if (this.isExam())
      return 'completed';
    else if (this.availability.score < 0.5) return 'bad';
    else if (this.availability.score < 0.95) return 'enough';
    else return 'perfect';
  }

  getName() {
    return this.exercise.shortName;
  }

  routeToTheSession(session: V3ExerciseSession) {
    this.router.navigate([`${this.fullpath}/session/${session.deviceUUID}/1`]).then();
  }

  routeToTheExamSession(session: V3ExamSession) {
    this.router.navigate([`${this.fullpath}/exam-session/${session.uuid}`]).then();
  }

  startSession() {
    if (this.getStatusClass() == 'locked') this.openLockedExerciseSetModal.emit()
    else if (this.isBlocked()) this.openCompletedExamResultModal.emit(this.exercise as V3Exam)
    else {
      this.isExam()
        ? this.startExamSession()
        : this.startExerciseSession()
    }
  }

  private startExerciseSession() {
    this.provider
      .cspaV3()
      .pipe(switchMap((api) => api.createSession(this.personId, {path: this.path})))
      .subscribe((session) => {
        this.routeToTheSession(session);
      });
  }

  private startExamSession() {
    this.provider
      .cspaV3()
      .pipe(switchMap((api) => api.createExamSession(this.personId, {path: this.path})))
      .subscribe((session) => {
        this.routeToTheExamSession(session);
      });
  }

  isBlocked() {
    return this.exercise['@type'] == 'V3Exam' && this.exercise.path != "ex0" && this.availability?.progress == 1
  }

  private isExam(): boolean {
    return this.exercise['@type'] === 'V3Exam'
  }
}
